export const UI_METRICS = {
    ESTIMATED_MB_PER_MP: 0.25
};
